import * as React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={`
          flex h-10 w-full rounded-md border bg-white px-3 py-2 text-sm placeholder:text-neutral-400 
          focus:outline-none focus:ring-2 focus:ring-black/5 disabled:cursor-not-allowed disabled:opacity-50
          ${error ? "border-red-500 focus:ring-red-500/20" : "border-neutral-300 text-neutral-900"} 
          ${className}
        `}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";


